var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaterDrop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16.0 20.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "water_drop_i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420,0 L420,1738 L0,1738 L0,0 L420,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "water_drop_i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C13.33,4.55 16,8.48 16,11.8 C16,16.78 12.2,20 8,20 C3.8,20 0,16.78 0,11.8 C0,8.48 2.67,4.55 8,0 Z M3.83,12 C3.37,12 3.01,12.42 3.09,12.87 C3.66,15.9 6.15,17.12 8.28,16.99 C8.68,16.97 9,16.64 9,16.24 C9,15.81 8.64,15.47 8.21,15.49 C6.85,15.6 4.98,14.84 4.57,12.62 C4.5,12.26 4.2,12 3.83,12 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-232.0 -64.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#water_drop_i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.9999999999986 62.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.0 2.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#water_drop_i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 16,0 16,20 0,20 0,0",
    stroke: "none",
    fill: "currentColor"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterDrop);
export default __webpack_public_path__ + "static/media/water_drop.d7c38034d5b7dc12751b46c712786bfb.svg";
export { ForwardRef as ReactComponent };